import { put, call } from 'redux-saga/effects';
import { productCreateAPI, productSearchAPI, productUpdateAPI } from 'src/api/ProductApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { PRODUCT_ACTIONS } from '../actions/ProductActions';

function* search({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true, caseSensitiveSearchProperties = [],
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(productSearchAPI, {
            where: buildSearchWithNoCase({
                where,
                fullTextSearch,
                caseSensitiveSearchProperties,
            }),
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });

        yield put({
            type: PRODUCT_ACTIONS.PRODUCT_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: PRODUCT_ACTIONS.PRODUCT_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({
    _id,
}) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(productSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });

        if (!data || !data[0]) {
        // DATA NO FOUND
            yield put(headerShowAction({
                data: 'Unable to Edit, something when wrong',
            }));
        }

        // add in reducer
        yield put({
            type: PRODUCT_ACTIONS.PRODUCT_UPSERT_SUCCESS,
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(productCreateAPI, payload);

        yield put(headerShowAction({
            data: 'Created',
        }));

        // add in reducer
        yield put({
            type: PRODUCT_ACTIONS.PRODUCT_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: PRODUCT_ACTIONS.PRODUCT_UPSERT_ERROR,
        });
    }
}

function* update(productId, payload) {
    try {
        yield call(productUpdateAPI, {
            productId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));

        yield edit({ _id: productId });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: PRODUCT_ACTIONS.PRODUCT_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(PRODUCT_ACTIONS.PRODUCT_SEARCH, search),
    takeFirstSagaUtil(PRODUCT_ACTIONS.PRODUCT_UPSERT, upsert),
    takeFirstSagaUtil(PRODUCT_ACTIONS.PRODUCT_EDIT, edit),
];
